import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep3_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F56.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame56() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {

    }, [])

    
        return (
            <div className="F56_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F56_entryBox">
                    <div className="F56_paragraph">
                        {language === 'english' ?
                            <p className="F56_paragraphEnglish">Saira gathers courage and tells the elder schoolgirls that there are indeed benefits of having a sanitary station in school</p>
                            :
                            <p className="F56_paragraphUrdu"> سائرا ہمت کرکے اپنی سے بڑی کلاس کی لڑکیوں کے پاس جاتی ہے </p>
                        }
                    </div>

                    <div className="F56_timeline">
                        <div className='F56_timelineBar'>
                            <div className='F56_timelineFill'></div>
                            <span className='F56_timelineText'>6/14</span>
                        </div>
                    </div>

                    <div className="F56_nextFrames">
                        <div className="F56_nextFrame1"></div>
                        <div className="F56_nextFrame2"></div>
                        <div className="F56_nextFrame3"></div>
                    </div>

                    <div className='F56_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep3_lastVisitFrame(6)) }} className='F56_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    
}

export default Frame56;